/**
 * @fileoverview Application Configuration
 * @description Central configuration file for the application
 * @module config/app
 */

// Runtime config from envconfig.js (injected at container startup)
const runtimeEnv = window.__ENV__ || {};

export const APP_CONFIG = {
  name: 'QE Portal',
  version: '1.0.0',
  company: 'Alaska Airlines',
  description: 'Quality Engineering Portal',
  
  // API Configuration
  // Priority: Vite env (dev) → runtime envconfig.js (prod) → default
  api: {
    baseUrl: import.meta.env.VITE_API_BASE_URL || runtimeEnv.VITE_API_BASE_URL || 'http://10.80.98.62:5000/api',
    timeout: 30000,
    retryAttempts: 3,
  },
  
  // Feature Flags
  features: {
    enableAnalytics: true,
    enableTestGenerationLink: true,
    enableDarkMode: true,
    enableNotifications: true,
  },
  
  // Pagination Defaults
  pagination: {
    defaultPageSize: 10,
    pageSizeOptions: [10, 25, 50, 100],
  },
  
  // Date/Time Formats
  dateFormats: {
    display: 'MM/DD/YYYY',
    api: 'YYYY-MM-DD',
    dateTime: 'MM/DD/YYYY HH:mm',
  },
};

export default APP_CONFIG;
